import { ThemeMode } from '../types/index.ts';

const THEME_KEY = 'theme';

export function initTheme(): void {
  const themeToggleBtn = document.getElementById('themeToggleBtn');
  if (!themeToggleBtn) return;

  themeToggleBtn.addEventListener('click', () => {
    const isDark = document.documentElement.classList.contains('dark');
    const newTheme: ThemeMode = isDark ? 'light' : 'dark';

    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    try {
      localStorage.setItem(THEME_KEY, newTheme);
    } catch {
      // Ignorar erros caso localStorage esteja desabilitado
    }
  });
}
